import { useMutation } from 'react-query'
import { useHistory } from 'react-router-dom'
import { routePaths } from 'global/routePaths'
import { endpoints } from 'global/endpoints'
import http from 'utils/http'
import { toast } from 'react-toastify'

const editCategory = ({ ...postData }) => {
  if (postData.id) {
    const updatedEndpoints = endpoints.category.base
    return http('multipart').put(updatedEndpoints, postData)
  }
}

export function useUpdateCategory() {
  const history = useHistory()

  return useMutation(editCategory, {
    onSuccess: () => {
      toast.success('Category has been edited successfully')
      history.push(routePaths.home.category.base)
    },
    onError: (err) => {
      console.log(err)
      toast.error('Unfortunately, update of category was not successful.')
    },
  })
}
